import React from 'react';

import {
  SearchInput2,
  Picker,
  TuneIcon,
  IconButton,
  ListItemText,
  Stack,
  Radio,
  Typography,
} from '@gogame/components';
import { SEARCH, useScreenDispatch, useScreenState } from '@gogame/screens';

import { SET_SEARCH_TYPE } from 'scenes/Gallery/GalleryPage/screenReducer';
import {
  SEARCH_BY_ID_NAME_TAG,
  SEARCH_BY_TRANSCRIPTION,
  SEARCH_BY_EVERYTHING,
} from 'scenes/Gallery/GalleryPage/constants';

window.dataLayer = window.dataLayer || [];

function emitGallerySearch({ type, query }) {
  window.dataLayer.push({
    event: 'gallerySearch',
    searchQuery: query,
    searchType: type,
  });
}

const SEARCH_OPTIONS = [
  {
    id: SEARCH_BY_ID_NAME_TAG,
    name: 'Search by id, name, tag',
  },
  {
    id: SEARCH_BY_TRANSCRIPTION,
    name: 'Search by transcript',
  },
  {
    id: SEARCH_BY_EVERYTHING,
    name: 'Search by everything',
  },
];

const SearchField = () => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();

  const { searchType, searchQuery = '' } = screenState;
  const [query, setQuery] = React.useState(() => searchQuery);

  const handleChangeSearchType = (selectedOptions) => {
    const type = [...selectedOptions].pop()?.id;
    dispatch({
      type: SET_SEARCH_TYPE,
      payload: {
        query,
        type,
      },
    });
    //
    if (query) {
      emitGallerySearch({ query, type });
    }
  };

  const searchPlaceholder = SEARCH_OPTIONS.find(
    (opt) => opt.id === searchType
  )?.name;

  const handleEnter = async (_e, value) => {
    dispatch({
      type: SEARCH,
      payload: { query: value },
    });
    if (value && searchType) {
      emitGallerySearch({ query: value, type: searchType });
    }
  };

  const handleChange = (_e, value) => {
    setQuery(value);
  };

  const [pickerOpen, setPickerOpen] = React.useState(false);
  const inputRef = React.useRef(null);

  const [expanded, setExpanded] = React.useState(false);

  const selectedOptions = React.useMemo(() => {
    return SEARCH_OPTIONS.filter(({ id }) => id === searchType);
  }, [searchType]);

  const renderOption = (option, { selected }) => {
    const label = option.name;
    return (
      <Stack direction={'row'} spacing={1} alignItems={'center'} ml={-1.5}>
        <Radio checked={selected} sx={{ pointerEvents: 'none' }} />
        <ListItemText
          disableTypography={true}
          primary={<Typography noWrap={true}>{label}</Typography>}
        />
      </Stack>
    );
  };

  const handleClear = () => {
    setQuery('');
  };

  return (
    <SearchInput2
      onChange={handleChange}
      placeholder={searchPlaceholder}
      tooltip={searchPlaceholder}
      expandedWidth={225}
      value={searchQuery}
      onEnter={handleEnter}
      onClear={handleClear}
      debounceTimeout={0}
      expanded={expanded}
      ref={inputRef}
      actions={[
        <Picker
          selectedOptions={selectedOptions}
          button={
            <IconButton
              tooltip={'Search options'}
              size={'small'}
              fontSize={16}
              icon={<TuneIcon />}
            />
          }
          open={pickerOpen}
          options={SEARCH_OPTIONS}
          onChange={handleChangeSearchType}
          onOpen={() => {
            setPickerOpen(true);
            setExpanded(true);
          }}
          onClose={() => {
            setPickerOpen(false);
            setTimeout(() => {
              inputRef.current.focus();
              setExpanded(false);
            }, 0);
          }}
          renderOption={renderOption}
        />,
      ]}
    />
  );
};
export default SearchField;
